import * as React from "react";
import {IChangeDraggingElementPayload} from "src/store/actions";
import {EFruits} from "src/store/enums";
import {IDraggingElement} from "src/store/models";
import * as kiwi from '../../assets/kiwi.svg';
import * as lemon from '../../assets/lemon.svg';
import * as orange from '../../assets/orange.svg';

interface IProps {
    boxId: string;
    kind: EFruits;
    size: number;
    fruitId: string;
    draggingElement: IDraggingElement;
    drag: (payload: IChangeDraggingElementPayload) => void;
}

export class FruitView extends React.Component<IProps, {}> {

    public Pics = {
        [EFruits.KIWI]: kiwi,
        [EFruits.ORANGE]: orange,
        [EFruits.LEMON]: lemon
    };

    public handleDragStart = (e: React.DragEvent) => {
        this.props.drag({
            id: this.props.fruitId,
            type: 'fruit'
        });
        e.stopPropagation();
    };

    public render() {
        const {kind, size, draggingElement, fruitId} = this.props;
        const isDraggingClass = draggingElement.id === fruitId ? `FruitView--dragging` : '';

        return (
            <div
                className={`FruitView size-${size} ${isDraggingClass}`}
                draggable={true}
                onDragStart={this.handleDragStart}
            >
                <div>
                    <img src={this.Pics[kind]} alt="image"/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/view/FruitView.tsx